import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import styles from './SubmissionSuccess.module.less';
import elementTypeIds from '../../constants/element-types';
import { Images } from '../../style';
import {
  getCustomCampaignSuccessPageData,
  fetchCampaignInfo,
  getCampaignRewardEnabled,
  getCampaignRewardAmount,
} from '../../redux/modules/campaignLandingPage';
import RichText from '../../components/CampaignSuccess/RichTextLandingPageElement';
import ImageElement from '../../components/CampaignLanding/ImageElement';
import SocialMediaElement from '../../vp-ui/components/SocialMediaElement/SocialMediaElement';
import RewardSuccessMessage from '../../components/CampaignLanding/RewardSuccessMessage';
import { Stack } from '@mui/material';
import { getWhiteLabelBrandByHost } from '@src/constants/white-label-brands';

const SubmissionSuccess = ({ customLandingPage, _fetchCampaignInfo, rewardEnabled, rewardAmount }) => {
  const whiteLabelBrand = getWhiteLabelBrandByHost();

  useEffect(() => {
    if (!customLandingPage) {
      const locationArray = window.location.pathname.split('/');
      const campaignLink = locationArray[locationArray.length - 2];
      _fetchCampaignInfo(campaignLink);
    }
  }, [customLandingPage, _fetchCampaignInfo]);

  const imageElement = customLandingPage?.campaignSuccessPageElements?.find(
    (e) => e.elementTypeId === elementTypeIds.IMAGE
  );
  const richTextElement = customLandingPage?.campaignSuccessPageElements?.find(
    (e) => e.elementTypeId === elementTypeIds.RICH_TEXT
  );

  const socialMediaIcons = customLandingPage?.campaignSuccessPageElements?.filter(
    (e) => e.elementTypeId === elementTypeIds.SOCIAL_MEDIA && e.mediaUrl
  );

  if (
    customLandingPage?.type === 'DESIGN' &&
    customLandingPage?.campaignSuccessPageElements?.length > 0
  ) {
    // Custom success page made of elements
    return (
      <main className={styles.vpCampaignLandingPageContainer}>
        <section>
          <Stack gap="15px">
            {imageElement && <ImageElement element={imageElement} />}
            {richTextElement && <RichText element={richTextElement} />}
            {rewardEnabled && rewardAmount > 0 && (
              <RewardSuccessMessage amount={rewardAmount} />
            )}
            {socialMediaIcons && <SocialMediaElement elements={socialMediaIcons} />}
          </Stack>
        </section>
      </main>
    );
  } else {
    // Default VideoPeel success page
    return (
      <main className={styles.vpCampaignLandingPageContainer}>
        <section>
          <div>
            <h1 className={styles.vpSubmitSuccessH1}>Thank You!</h1>
            {!whiteLabelBrand?.hideVideoPeelLogoOnThankYouPage && (
              <img src={Images.vpSwirl} alt="vp-logo" />
            )}
            {rewardEnabled && rewardAmount > 0 && (
              <RewardSuccessMessage amount={rewardAmount} />
            )}
          </div>
        </section>
      </main>
    );
  }
};

SubmissionSuccess.propTypes = {
  customLandingPage: PropTypes.object,
  _fetchCampaignInfo: PropTypes.func.isRequired,
  rewardEnabled: PropTypes.bool,
  rewardAmount: PropTypes.number,
};

function mapStateToProps(state) {
  return {
    customLandingPage: getCustomCampaignSuccessPageData(state),
    rewardEnabled: getCampaignRewardEnabled(state),
    rewardAmount: getCampaignRewardAmount(state),
  };
}

const mapDispatchToProps = {
  _fetchCampaignInfo: fetchCampaignInfo
};

export default connect(mapStateToProps, mapDispatchToProps)(SubmissionSuccess);



// WEBPACK FOOTER //
// ./src/containers/CampaignLandingPage/SubmissionSuccess.jsx